export var SeatsPosition = [
    { top: "-15px", left: "calc(50% - 15px)" }, // Seat 1
    { top: "-10px", left: "calc(50% + 55px)" }, // Seat 2
    { bottom: "calc(50% - 15px)", right: "-20px" }, // Seat 3
    { bottom: "-15px", left: "calc(50% - 15px)" }, // Seat 4
    { bottom: "-10px", left: "calc(50% + 55px)" }, // Seat 5
    { bottom: "-10px", left: "calc(50% - 85px)" }, // Seat 6
    { bottom: "calc(50% - 15px)", left: "-20px" }, // Seat 7
    { top: "-10px", left: "calc(50% - 85px)" }, // Seat 8
];
